import React from 'react';
// import './App.css';
import { BrowserRouter, Route, Switch, Link, Redirect } from 'react-router-dom';
import Login from '../Login/login';
import { Navbar, Nav } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import useToken from './useToken';
import Teams from '../Teams/GetTeams';
import Match from '../Matchs/match';
import Bet from '../Bets/bets';
import OtherBet from '../OtherBets/otherbets';
import Dashboard from '../Dashboard/Dashboard';
import Settings from '../Settings/settings';
import AdminSpecialPredictions from '../AdminSpecialPredictions/AdminSpecialPredictions';
import AdminUsers from '../AdminUsers/AdminUsers';
import '../UserResponsive.css';


function App() {
  const { token, setToken, roles } = useToken();
  if (!token) {
    return <Login setToken={setToken} />
  }

  const isAdmin = roles.includes('SuperAdmin');
  const shellClassName = isAdmin ? 'wrapper app-shell admin-shell' : 'wrapper app-shell client-theme';

  return (
    <BrowserRouter>
      <div className={shellClassName}>
      <Ppal setToken={setToken} isAdmin={isAdmin}/>
        <main className="app-content">
        <Switch>
          <Route exact path="/">
            <Redirect to="/reglas" />
          </Route>
          <Route exact path="/reglas">
            <Dashboard />
          </Route>
          <Route exact path="/teams">
            {isAdmin ? <Teams /> : <Redirect to="/reglas" />}
          </Route>
          <Route path="/matchs">
            {isAdmin ? <Match /> : <Redirect to="/reglas" />}
          </Route>
          <Route path="/mybets">
            {isAdmin ? <Redirect to="/otherbets" /> : <Bet visit="0"/>}
          </Route>
          <Route path="/otherbets">
            <OtherBet />
          </Route>
          <Route path="/settings">
            {isAdmin ? <Settings /> : <Redirect to="/reglas" />}
          </Route>
          <Route path="/users">
            {isAdmin ? <AdminUsers /> : <Redirect to="/reglas" />}
          </Route>
          <Route path="/special-results">
            {isAdmin ? <AdminSpecialPredictions /> : <Redirect to="/reglas" />}
          </Route>
          <Route path="/salir">
            {/* { setToken (null) } */}
          </Route>
          <Route path="*">
            <Redirect to="/reglas" />
          </Route>
        </Switch>
        </main>
        <footer className="app-footer">
          Desarrollado por © OneSoft 2026
        </footer>
      </div>
    </BrowserRouter>
  );
}


export default App;

function Ppal( {setToken, isAdmin} ) {
  const handleLogout = () => {
    sessionStorage.removeItem('token');
    setToken(null);
  };

  return (
    <Navbar bg="primary" variant="dark" expand="lg"  >
      <Container>
        <Navbar.Brand as={Link} to="/">PollaGol 2026</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="justify-content-end flex-grow-1 pe-3" variant="pills"  >
              {!isAdmin && <Nav.Link as={Link} to="/mybets">Mis apuestas</Nav.Link>}
              <Nav.Link as={Link} to="/reglas">Reglas</Nav.Link>
              {isAdmin && <Nav.Link as={Link} to="/teams">Selecciones</Nav.Link>}
              {isAdmin && <Nav.Link as={Link} to="/matchs">Partidos</Nav.Link>}
              {isAdmin && <Nav.Link as={Link} to="/special-results">Especiales</Nav.Link>}
              {isAdmin && <Nav.Link as={Link} to="/users">Usuarios</Nav.Link>}
              {isAdmin && <Nav.Link as={Link} to="/settings">Configuración</Nav.Link>}
              <Nav.Link as={Link} to="/otherbets">Otros resultados</Nav.Link>
              <Nav.Link onClick={handleLogout}>Salir</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>

);

}
